import { render, staticRenderFns } from "./YBLogin.vue?vue&type=template&id=621780d4&"
import script from "./YBLogin.vue?vue&type=script&lang=js&"
export * from "./YBLogin.vue?vue&type=script&lang=js&"
import style0 from "./YBLogin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports